import { render } from "./QueryChart.vue?vue&type=template&id=5acc263e&ts=true"
import script from "./QueryChart.vue?vue&type=script&lang=ts"
export * from "./QueryChart.vue?vue&type=script&lang=ts"

import "./QueryChart.vue?vue&type=style&index=0&id=5acc263e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QSpinnerDots,QDialog,QCard,QCardSection,QSpace,QBtn,QSeparator});qInstall(script, 'directives', {ClosePopup});
